import * as Yup from 'yup';
import { hasCitiesAvailable } from 'src/utils/address';

export default (addressData = { cities: [] }, isLoadingAddress = false) => {
  const hasCities = hasCitiesAvailable(addressData, isLoadingAddress);
  
  return Yup.object().shape({
    zipCode: Yup.string()
      .matches(/^[0-9]{5}$/, 'SCHEMA_ERRORS.ZIP_CODE_INVALID')
      .required('SCHEMA_ERRORS.CLIENT_DETAIL_FORM.ZIP_CODE_INVALID'),
    street: Yup.string(),
    insideHomeNumber: Yup.string().nullable(),
    externalHomeNumber: Yup.string(),
    colonia: Yup.string(),
    city: hasCities
      ? Yup.string().required('SCHEMA_ERRORS.CITY_REQUIRED')
      : Yup.string().nullable(),
    state: Yup.string(),
    municipality: Yup.string(),
    country: Yup.string()
  });
};
